import { get, post, put, del } from "./request";

// ==================== 认证登录 ====================

/** 管理员登录 */
export function AdminLogin(params) {
  return post("/system/auth/adminLogin", params);
}
/** 教师登录（旧 system 接口，教师端已改用 @/api/teacher/auth） */
export function TeacherLogin(params) {
  return post("/system/auth/teacherLogin", params);
}
/** 获取图形验证码 */
export function getCaptchaImage() {
  return get("/system/auth/captchaImage");
}

// ==================== 当前用户 ====================

/** 获取当前用户个人资料 */
export function getProfile() {
  return get("/system/user/profile");
}

/** 获取当前用户权限信息（含 permissions 数组） */
export function getAuthInfo() {
  return get("/system/user/getInfo");
}

/** 修改当前用户个人资料 */
export function updateProfile(data) {
  return put("/system/user/profile", data);
}

/** 修改当前用户登录密码 */
export function updateProfilePwd(data) {
  return put("/system/user/profile/updatePwd", data);
}

/** 获取当前用户动态路由菜单 */
export function getRouters() {
  return get("/education-system/menu/getRouters");
}

// ==================== 数据字典 - 类型 ====================

/** 分页查询字典类型列表 */
export function getDictTypeList(params) {
  return get("/system/dict/type/list", params);
}

/** 查询字典类型详情 */
export function getDictType(dictId) {
  return get(`/system/dict/type/${dictId}`);
}

/** 新增字典类型 */
export function addDictType(data) {
  return post("/system/dict/type", data);
}

/** 修改字典类型 */
export function updateDictType(data) {
  return put("/system/dict/type", data);
}

/** 删除字典类型 */
export function deleteDictType(dictIds) {
  return del(`/system/dict/type/${dictIds}`);
}

/** 刷新字典缓存 */
export function refreshDictCache() {
  return del("/system/dict/type/refreshCache");
}

// ==================== 数据字典 - 数据 ====================

/**
 * 全量字典（与门户 / 学员端一致）
 * GET /web-api/member-web/memberWechat/dictAll
 */
export function getDictAll() {
  return get("/web-api/member-web/memberWechat/dictAll", null, {
    baseURL: "/"
  });
}

/** 分页查询字典数据列表（字典管理页） */
export function getDictDataList(params) {
  return get("/system/dict/data/list", params);
}

/** 查询字典数据详情 */
export function getDictData(dictCode) {
  return get(`/system/dict/data/${dictCode}`);
}

/** 新增字典数据 */
export function addDictData(data) {
  return post("/system/dict/data", data);
}

/** 修改字典数据 */
export function updateDictData(data) {
  return put("/system/dict/data", data);
}

/** 删除字典数据 */
export function deleteDictData(dictCodes) {
  return del(`/system/dict/data/${dictCodes}`);
}



// WEBPACK FOOTER //
// ./src/api/system.js